var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThetaIntelligence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 68,
    viewBox: "0 0 52 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -0.06,
    cy: -0.052,
    r: 1.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4688b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#7131ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(-924 -2263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M972.668,2267H927.332a3.147,3.147,0,0,0-3.147,3.147v39.545a6.3,6.3,0,0,0,2.66,5.139l19.521,13.8a6.294,6.294,0,0,0,7.268,0l19.521-13.8a6.3,6.3,0,0,0,2.66-5.139v-39.545A3.147,3.147,0,0,0,972.668,2267Zm-37.3,10.659a.63.63,0,0,1,.63-.63h15.56a.629.629,0,0,1,.629.63v3.641a.628.628,0,0,1-.629.629H936a.629.629,0,0,1-.63-.629Zm16.823,12.733a.629.629,0,0,1-.629.63h-4.346a.629.629,0,0,0-.629.629v18.385a.629.629,0,0,1-.629.629h-4.315a.629.629,0,0,1-.63-.629v-18.385a.629.629,0,0,0-.629-.629H936a.63.63,0,0,1-.63-.63v-3.643a.63.63,0,0,1,.63-.63h15.564a.629.629,0,0,1,.629.63Zm11.182,19.653a.629.629,0,0,1-.629.629h-4.315a.63.63,0,0,1-.63-.629v-23.12a.63.63,0,0,1,.63-.63h4.315a.63.63,0,0,1,.629.63Zm0-28.745a.629.629,0,0,1-.629.629h-4.315a.629.629,0,0,1-.63-.629v-3.641a.63.63,0,0,1,.63-.63h4.315a.63.63,0,0,1,.629.63Z",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 52,
    height: 68,
    transform: "translate(924 2263)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThetaIntelligence);
export default __webpack_public_path__ + "static/media/theta-intelligence.2c9105db3abadfe87660f4e28d075bbc.svg";
export { ForwardRef as ReactComponent };